import { Component } from '@angular/core';
import { EcitationReportService } from 'src/services/ecitation-report.service';
import * as XLSX from 'xlsx';
import { FileSaverService } from 'ngx-filesaver';
@Component({
    selector: 'app-ecitation-agency-annual-report',
    templateUrl: './ecitation-agency-annual-report.component.html',
    styleUrls: ['./ecitation-agency-annual-report.component.css'],
    standalone: false
})
export class EcitationAgencyAnnualReportComponent {
  showReportResults = false;
  selectedYear: number = new Date().getFullYear();
  listOfYearsOptions: number[] = [];
  outPut: any = [];
  outPutRes: any = [];
  total: any;
  constructor(private ecitationReportService: EcitationReportService, private fileSaverService: FileSaverService) {
    for (let i = 0; i <= 4; i++) {
      const cYear: number = new Date().getFullYear();
      this.listOfYearsOptions.push(cYear - i)
    }

  }

  pageSize: number = 25;
  currentPage: number = 1;

  getItems() {
    const satrtIndex = (this.currentPage - 1) * this.pageSize;
    return this.outPut.slice(satrtIndex, satrtIndex + this.pageSize);
  }

  onPageChange(pageNumber: number) {
    this.currentPage = pageNumber
  }

  getTotalPages(): number {
    return Math.ceil(this.outPut.length / this.pageSize);
  }

  getVisiblePages(): number[] {
    const totalVisiblePages = 10;
    const visiblePages: number[] = [];
    const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages / 2));
    const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i)
    }
    return visiblePages
  }
  getAnnualSummary() {
    this.ecitationReportService.getAgencyAnnualReport(this.selectedYear).subscribe((res) => {
      this.outPutRes = res;
      console.log(this.outPutRes)
      this.outPut = res;
    
      if (this.outPut.length > 0) {
        this.outPut.filter((x: any, i: number) => {
          x.date = i + 1 == this.outPut.length ? 'Total' : x.date
        })
        this.total = this.outPut.pop()
      }
      this.showReportResults = true;

    })
  }
  getCurrentPageTotal() {
    if (this.currentPage * 10 > this.outPut.length) {
      return this.outPut.length
    } else {
      return this.currentPage * 10
    }
  }
  
  excelExport() {
    
    const downloadData  = this.outPut;
    downloadData.push(this.total)
    console.log(downloadData)
   
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    const headers = ['Year','Month', 'DNR', 'Police', 'Sheriff', 'State Patrol', 'Other', 'Total Submitted']
    const worksheet = XLSX.utils.json_to_sheet([], { header: headers })
    XLSX.utils.sheet_add_json(worksheet, downloadData, { origin: 'A2', skipHeader: true });

  const workbook = {
    Sheets: {
      'Agency-Annual-Report': worksheet
    },
    SheetNames: ['Agency-Annual-Report']
  }

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blobData = new Blob([excelBuffer], { type: EXCEL_TYPE })
    this.fileSaverService.save(blobData, `Agency-Annual-Report-${this.selectedYear}`)
    this.total = this.outPut.pop()
  }
}
